module.exports = __webpack_public_path__ + "static/media/Categoria8Ferreteria.55fdd582.jpg";